import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleBudgetProvide } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetProvideComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const budgetProvideCombo = computed(() => {
    const budgetProvides = store.getters[`${ModuleBudgetProvide}/items`];
    return budgetProvides.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheBudgetProvideComboConfig = reactive({
    data: budgetProvideCombo,
    columns: [
      {
        title: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Diễn giải',
        dataField: 'budget_provide_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'budget_provide_code',
    valueField: 'budget_provide_code',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_provide_code',
      titleSearch: 'Tìm nhanh mã dự phòng',
    },
  });

  return {
    cacheBudgetProvideComboConfig,
  };
};
